import { styled } from 'next-yak';

import { spaceS } from '@xing-com/tokens';

export const HeaderSection = styled.section`
  display: flex;
  flex-direction: column;
  min-height: 226px;
  justify-content: space-between;
`;

export const HeaderContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceS};
`;
